var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgWorkModeIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 12,
    viewBox: "0 0 16 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.9987 8.66663V2.79996C13.9987 2.05322 13.9987 1.67985 13.8534 1.39464C13.7255 1.14376 13.5216 0.939782 13.2707 0.811951C12.9855 0.666626 12.6121 0.666626 11.8654 0.666626H4.13203C3.38529 0.666626 3.01193 0.666626 2.72671 0.811951C2.47583 0.939782 2.27185 1.14376 2.14402 1.39464C1.9987 1.67985 1.9987 2.05322 1.9987 2.79996V8.66663M3.10981 11.3333H12.8876C13.3009 11.3333 13.5076 11.3333 13.6771 11.2879C14.1372 11.1646 14.4966 10.8052 14.6199 10.3451C14.6654 10.1755 14.6654 9.96884 14.6654 9.55551C14.6654 9.34885 14.6654 9.24552 14.6426 9.16075C14.581 8.93069 14.4013 8.75099 14.1712 8.68934C14.0865 8.66663 13.9831 8.66663 13.7765 8.66663H2.22092C2.01426 8.66663 1.91093 8.66663 1.82615 8.68934C1.59609 8.75099 1.41639 8.93069 1.35475 9.16075C1.33203 9.24552 1.33203 9.34885 1.33203 9.55551C1.33203 9.96884 1.33203 10.1755 1.37746 10.3451C1.50075 10.8052 1.86015 11.1646 2.32027 11.2879C2.48983 11.3333 2.69649 11.3333 3.10981 11.3333Z",
    stroke: "black",
    strokeWidth: 1.2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWorkModeIcon);
export default __webpack_public_path__ + "static/media/WorkModeIcon.84fddcc874090dfd5c2abbc9dca3d7cf.svg";
export { ForwardRef as ReactComponent };